import { apiRequest } from './index';

export const fetchAttendanceRuleRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/attendance-rules/' + id, {}, success, failure);
}

export const fetchAttendanceRulesRequest = ( success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/attendance-rules', {}, success, failure);
}

export const createAttendanceRuleRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/attendance-rules',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editAttendanceRuleRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/attendance-rules/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

const buildAttendanceRuleOptions = attendanceRule => ({
    value: attendanceRule ? attendanceRule._id : '',
    label: attendanceRule ? attendanceRule.label : '',
    description: attendanceRule ? attendanceRule.description : '',
    data: attendanceRule
});

export const attendanceRuleSelectOptionRequest = (type, success = (result = []) => {}, failure = (error) => {}) =>{
    fetch(process.env.REACT_APP_API_ENDPOINT + '/attendance-rules?type=' + type)
        .then(response => response.json())
        .then(data => {
            const selectOptions = [];
            data.forEach((item) => {
                const option = buildAttendanceRuleOptions(item);
                selectOptions.push(option);
            });
            success(selectOptions);
        })
        .catch(error =>{
            failure(error.status);
        });
}

export const deleteAttendanceRuleRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/attendance-rules/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}
